<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar title="Search" :icon="require('@/assets/admin-icon/menu/search_active.svg')">
        <div class="options"></div>
      </WidgetToolbar>
    </div>

    <div class="page-body">
      <div class="search-section">
        <div class="search-inputs">
          <div class="search-widget-wrapper" id="main-search-input">
            <widgetSearch :loading="search_loading" placeholder="Search here" v-model="search_text"
              @keypress="submitSearch()" @keyup="submitSearch()" icon="right"></widgetSearch>
          </div>
          <div class="search-category-widget" id="main-search-filter">
            <widgetMiltSelect v-model="search_categories_input" placeholder="Select Category"
              selectedholder="Selected Categories"></widgetMiltSelect>
          </div>
          <div class="search-action" id="main-search-btn">
            <widgetButton @click="submitSearch()" class="btn-secondary search-btn">
              Search
            </widgetButton>
          </div>
        </div>
        <div class="search-tags">
          <div class="search-tags-left-panel">
            <template v-for="(item, index) in search_categories_input">
              <widgetTagItem v-if="item.checked" :key="index" :value="item.name" @remove="removeSearchInCategory(item)">
              </widgetTagItem>
            </template>
          </div>
          <div class="search-tags-right-panel">
            <widgetButton v-if="isActiveFilter" class="btn-transparent-secondary fit-content" href="#"
              @click="clearFilter()">Clear Filter</widgetButton>
          </div>
        </div>
      </div>

      <!-- Search result -->
      <div class="search-result-widget" v-if="search_result && isDataAvailable">
        <div v-if="search_site_result.length > 0" class="search-result-count">
          All results ({{
            search_site_result.length ||
            0 + search_result.Contacts.length ||
            0 + search_result.Accounts.length ||
            0 + search_result.Candidates.length ||
            0 + search_result.Leads.length ||
            0 + search_result.Tasks.length ||
            0
          }})
        </div>

        <template v-if="search_site_result && isSearchParamExists('profile')">
          <div v-if="search_site_result.length > 0" class="search-result-header">
            Consultants({{ search_site_result.length || 0 }})
          </div>
          <div class="search-item" v-for="(item, index) in search_site_result" :key="index + '_student'"
            @click="navigateToStudent(item)">
            <div class="row">
              <widgetProfile :title="item.first_name + ' ' + item.last_name" :subtitle="item.email"
                :file_name="item.profile_picture" :path="$fullUrl('images/profiles/')" @click="() => { }"></widgetProfile>
            </div>
          </div>
        </template>

        <template v-if="search_result.Contacts">
          <div v-if="search_result.Contacts.length > 0" class="search-result-header">
            Contacts
          </div>
          <template v-for="(item, index) in search_result.Contacts">
            <div class="search-item" :key="index + '_contact'" @click="
              $router.push({
                name: 'accounts',
                params: { type: 'contacts', id: item.id },
              })
              " v-if="item.first_name && item.last_name">
              <div class="row">
                <widgetProfile :title="item.first_name + ' ' + item.last_name" :subtitle="item.email" @click="() => { }">
                </widgetProfile>
              </div>
            </div>
          </template>
        </template>

        <template v-if="search_result.Accounts">
          <div v-if="search_result.Accounts.length > 0" class="search-result-header">
            Accounts
          </div>
          <div class="search-item" v-for="(item, index) in search_result.Accounts" :key="index + 'accounts'" @click="
            $router.push({
              name: 'account-view',
              params: { type: 'overview', id: item.id },
            })
            ">
            <div class="row">
              <widgetProfile :title="item.name" :subtitle="item.location" @click="() => { }"></widgetProfile>
            </div>
          </div>
        </template>

        <div v-if="(search_result.Candidates && search_result.Candidates.length > 0) ||
          (search_result.Leads && search_result.Leads.length > 0) ||
          (search_result.Tasks && search_result.Tasks.length > 0)
          " class="search-result-header">
          Tasks, Leads and Candidates
        </div>
        <div class="search-item" v-for="(item, index) in search_result.Candidates" :key="index + '_candidate'" @click="
          $router.push({
            name: 'candidates',
            params: { id: item.id },
          })
          ">
          <div class="row">
            <candidatesItemWidget :title="item.name" subtitle="Candidate" @click="() => { }"></candidatesItemWidget>
          </div>
        </div>
        <div class="search-item" v-for="(item, index) in search_result.Leads" :key="index + '_lead'" @click="
          $router.push({
            name: 'leads',
            params: { id: item.id },
          })
          ">
          <div class="row">
            <leadsItemWidget :title="item.name" subtitle="Lead" @click="() => { }"></leadsItemWidget>
          </div>
        </div>

        <div class="search-item" v-for="(item, index) in search_result.Tasks" :key="index + '_task'" @click="
          $router.push({
            name: 'task',
            params: { id: item.id },
          })
          ">
          <div class="row">
            <taskItemWidget :title="item.name" subtitle="Task" @click="() => { }"></taskItemWidget>
          </div>
        </div>
      </div>
      <!-- No search result -->
      <div v-else class="search-notfound-widget">
        <div class="empty-widget-body" v-if="!search_text && !search_loading">
          <widgetNotFoundWidget content="Your search results will be displayed here" align="left">
            <img class="widget-img" src="@/assets/icons/search-not-found.svg" />
          </widgetNotFoundWidget>
        </div>
        <div class="empty-widget-body" v-if="search_text && search_result && !isDataAvailable && !search_loading
          ">
          <widgetNotFoundWidget content="No results were found; try a new keyword." align="left">
            <img class="widget-img" src="@/assets/icons/search-not-found.svg" />
          </widgetNotFoundWidget>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import taskItemWidget from "@/views/Search/components/taskItemWidget.vue";
import candidatesItemWidget from "@/views/Search/components/candidatesItemWidget.vue";
import leadsItemWidget from "@/views/Search/components/leadsItemWidget.vue";

export default {
  name: "Search",
  components: {
    taskItemWidget,
    candidatesItemWidget,
    leadsItemWidget,
  },
  data() {
    return {
      search_text: "",
      search_categories_input: [
        {
          name: "Contacts",
          value: "contacts",
          checked: true,
        },
        {
          name: "Leads",
          value: "leads",
          checked: true,
        },
        {
          name: "Tasks",
          value: "tasks",
          checked: true,
        },
        {
          name: "Candidates",
          value: "candidates",
          checked: true,
        },
        {
          name: "Accounts",
          value: "accounts",
          checked: true,
        },
        // {
        //   name: "Organisation",
        //   value: "organisation",
        //   checked: true,
        // },
        {
          name: "Profile",
          value: "profile",
          checked: true,
        },
        {
          name: "Tags",
          value: "tags",
          checked: true,
        },
      ],
      search_result: {
        Tasks: [],
        Contacts: [],
        Leads: [],
        Candidates: [],
        Accounts: [],
      },
      search_site_result: [],
      search_loading: false,
      team_ids: [],
      department_data: [],
    };
  },
  mounted() {
    let vm = this;
    let path = [
      {
        label: "Search",
        active: true,
      },
    ];
    vm.$store.commit("SET_PATH", path);
    vm.getDepartmentData();
  },
  watch: {},
  methods: {
    isSearchParamExists(param) {
      let vm = this;
      let category = vm.search_categories_input.find(
        (item) => item.value == param
      );
      if (category) {
        return category.checked;
      } else {
        return false;
      }
    },
    clearFilter() {
      let vm = this;
      vm.search_text = "";
      vm.search_result = {
        Tasks: [],
        Contacts: [],
        Leads: [],
        Candidates: [],
        Accounts: [],
      };
      vm.search_site_result = [];
      vm.submitSearch();
    },
    navigateToStudent(item) {
      let vm = this;
      vm.$router.push({
        name: "organization",
        params: { type: "manage" },
        query: {
          profile_type: "student",
          id: item.id,
          company_id: item.pivot.company_id,
        },
      });
    },
    getDepartmentData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("GET_ALL_USER_INFO")
        .then((response) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.department_data = response.data;
          vm.department_data.forEach((item) => {
            item.teams.forEach((team) => {
              vm.team_ids.push(team.id);
            });
          });
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    removeSearchInCategory(item) {
      let vm = this;
      item.checked = false;
      vm.submitSearch();
    },
    submitSearch() {
      let vm = this;
      if (vm.search_text) {
        vm.search_loading = true;
        vm.$store
          .dispatch("SEARCH_ALL_CRM", {
            query: vm.search_text,
            categories: vm.search_categories_input
              .filter((item) => item.checked)
              .map((item) => item.name),
            team_ids: vm.team_ids,
          })
          .then((response) => {
            vm.search_result = response.data;
            vm.$store
              .dispatch("SEARCH_ALL_SITE", {
                query: vm.search_text,
                categories: vm.search_categories_input,
                team_ids: vm.team_ids,
              })
              .then((response) => {
                vm.search_loading = false;
                vm.search_site_result = response.data;
              })
              .catch((error) => {
                vm.search_loading = false;
                console.error({ error });
              });
          })
          .catch((error) => {
            vm.search_loading = false;
            console.error({ error });
          });
      }
    },
  },
  computed: {
    isActiveFilter() {
      let vm = this;
      return vm.search_text.length > 0;
    },
    isDataAvailable() {
      let vm = this;
      if (vm.search_result) {
        if (vm.search_site_result && vm.search_site_result.length > 0) {
          return true;
        }

        if (vm.search_result.Tasks && vm.search_result.Tasks.length > 0) {
          return true;
        }
        if (vm.search_result.Contacts && vm.search_result.Contacts.length > 0) {
          return true;
        }
        if (vm.search_result.Leads && vm.search_result.Leads.length > 0) {
          return true;
        }
        if (
          vm.search_result.Candidates &&
          vm.search_result.Candidates.length > 0
        ) {
          return true;
        }
        if (vm.search_result.Accounts && vm.search_result.Accounts.length > 0) {
          return true;
        }
      }
      return false;
    },
  },
  created() { },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .options {
      display: flex;
      align-items: center;
    }
  }

  .page-body {
    height: calc(100% - 43px);
    border-radius: 5px;
    display: flex;
    flex-direction: column;

    .search-section {
      display: flex;
      flex-direction: column;
      background: #fff;
      padding: 8px;
      padding-bottom: 2px;
      border-radius: 5px;
      position: relative;
      height: 78px;

      .search-inputs {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        @media (min-width: 300px) and (max-width: 630px) {
          flex-direction: column;
          align-items: flex-start;
        }

        .search-widget-wrapper {
          width: 45%;
          margin-right: 8px;
        }

        .search-category-widget {
          margin-right: 10px;
          width: 250px;

          @media (min-width: 300px) and (max-width: 630px) {
            margin-top: 10px;
          }
        }

      }

      .search-tags {
        display: flex;
        justify-content: space-between;

        .search-tags-left-panel {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        }

        .search-tags-right-panel {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        }
      }
    }

    .search-result-widget {
      background: #fff;
      padding: 15px 15px;
      border-radius: 5px;
      margin-top: 5px;
      width: 100%;
      height: calc(100% - 80px);
      overflow-y: auto;

      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
      }

      .search-result-count {
        font-family: "Nunito";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        color: #323338;
        margin-bottom: 15px;
      }

      .search-result-header {
        font-family: "Nunito";
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        color: #676879;
        padding-bottom: 6px;
      }

      .search-item {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        padding: 2px 8px;
        cursor: pointer;
        border-radius: 5px;

        &:hover {
          background: rgb(241, 241, 241);
        }

        img {
          width: 30px;
          height: 30px;
          object-fit: cover;
          border-radius: 50%;
        }

        .content {
          display: flex;
          flex-direction: column;

          label {
            padding-left: 10px;
            display: block;
            margin-bottom: 5px;
            font-size: 15px;
          }

          .info-widget {
            display: flex;
            align-items: center;

            .info-item {
              color: #999faa;
              padding: 0px 10px;

              &.divider {
                border-right: 1px solid #999faa;
              }
            }
          }
        }
      }

      .result-counter-widget {
        display: flex;
        justify-content: space-between;
        padding-top: 10px;

        .result-number {
          color: #999faa;
        }

        .show-more-result {
          display: flex;
          align-items: center;
          cursor: pointer;

          button {
            margin-top: 2px;
          }
        }
      }
    }

    .search-notfound-widget {
      margin-top: 10px;
      width: 100%;
      height: calc(100% - 94px);
      overflow-y: auto;

      .empty-widget-body {
        background: #fff;
        padding: 15px 15px;
        border-radius: 5px;
      }
    }
  }
}
</style>
